"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UICardGrid;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Styles = require("../utils/Styles");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n\n  && {\n    margin-top: 0;\n  }\n\n  @supports (display: grid) {\n    display: none;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 0;\n  margin-left: -", ";\n  margin-right: 0;\n  margin-top: -", ";\n\n  && > * {\n    ", ";\n  }\n\n  @supports (display: grid) {\n    display: flex;\n    display: grid;\n    grid-column-gap: ", ";\n    grid-row-gap: ", ";\n    grid-template-columns: ", ";\n    margin: 0;\n\n    && > * {\n      margin: 0;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  flex-grow: ", ";\n  flex-shrink: 1;\n  flex-basis: ", ";\n  margin-bottom: 0;\n  margin-left: ", ";\n  margin-right: 0;\n  margin-top: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var getColumnSize = function getColumnSize(value, correction) {
  // subtract correction from % values
  if (typeof value === 'string' && /%$/.test(value)) {
    return "calc(" + value + " - " + (0, _Styles.toPx)(correction) + ")";
  } // convert raw numbers to px strings


  if (typeof value === 'number') {
    return (0, _Styles.toPx)(value);
  } // leave other string values alone


  return value;
};

var getTemplateColumns = function getTemplateColumns(_ref) {
  var columns = _ref.columns,
      columnSize = _ref.columnSize,
      gutterSize = _ref.gutterSize;
  if (columns) return "repeat(" + columns + ", 1fr)";
  var computedColumnSize = getColumnSize(columnSize, gutterSize);
  return "repeat(auto-fit, minmax(" + computedColumnSize + ", 1fr))";
};

var getFlexChildFallback = function getFlexChildFallback(_ref2) {
  var columns = _ref2.columns,
      columnSize = _ref2.columnSize,
      gutterSize = _ref2.gutterSize;
  return (0, _styledComponents.css)(_templateObject(), typeof columnSize === 'string' && /%$/.test(columnSize) ? '0' : '1', getColumnSize(columns ? Math.floor(100 / columns) + "%" : columnSize, gutterSize), (0, _Styles.toPx)(gutterSize), (0, _Styles.toPx)(gutterSize));
};

var CardGrid = _styledComponents.default.div.withConfig({
  displayName: "UICardGrid__CardGrid",
  componentId: "sc-1iwg3jb-0"
})(_templateObject2(), function (props) {
  return (0, _Styles.toPx)(props.gutterSize);
}, function (props) {
  return (0, _Styles.toPx)(props.gutterSize);
}, getFlexChildFallback, function (props) {
  return (0, _Styles.toPx)(props.gutterSize);
}, function (props) {
  return (0, _Styles.toPx)(props.gutterSize);
}, getTemplateColumns);

var CardShim = _styledComponents.default.div.withConfig({
  displayName: "UICardGrid__CardShim",
  componentId: "sc-1iwg3jb-1"
})(_templateObject3(), getFlexChildFallback);

function UICardGrid(_ref3) {
  var children = _ref3.children,
      className = _ref3.className,
      columnSize = _ref3.columnSize,
      gutterSize = _ref3.gutterSize,
      rest = (0, _objectWithoutProperties2.default)(_ref3, ["children", "className", "columnSize", "gutterSize"]);
  return _react.default.createElement(CardGrid, (0, _extends2.default)({}, rest, {
    className: className,
    columnSize: columnSize,
    gutterSize: gutterSize
  }), children, _react.default.createElement(CardShim, {
    columnSize: columnSize,
    gutterSize: gutterSize
  }), _react.default.createElement(CardShim, {
    columnSize: columnSize,
    gutterSize: gutterSize
  }), _react.default.createElement(CardShim, {
    columnSize: columnSize,
    gutterSize: gutterSize
  }), _react.default.createElement(CardShim, {
    columnSize: columnSize,
    gutterSize: gutterSize
  }), _react.default.createElement(CardShim, {
    columnSize: columnSize,
    gutterSize: gutterSize
  }));
}

UICardGrid.propTypes = {
  children: _propTypes.default.node,
  columns: _propTypes.default.number,
  columnSize: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  gutterSize: _propTypes.default.number
};
UICardGrid.defaultProps = {
  columnSize: 295,
  expandToFill: true,
  gutterSize: 32
};
UICardGrid.displayName = 'UICardGrid';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/card/UICardGrid.js
// module id = 434
// module chunks = 209 210 211 212